module.exports = __webpack_public_path__ + "static/image/company/pc/image_sustainable_declaration@3x.ver2_0_2.jpg?b2f0ed41";